export default __webpack_public_path__ + "static/media/svg.df739e93.svg";